import React from 'react';
import { Sparkles, Layers, ExternalLink } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerElement = document.querySelector('header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 80;
      const targetPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-badge">
          <Sparkles size={16} />
          <span>Independent Software Product Studio</span>
        </div>
        
        <h1>Engineering High-Impact Android Software Products</h1>
        <p className="hero-subtitle">
          JustLabs creates, publishes, and maintains focused, privacy-first Android software products 
          and specialized enterprise tools designed for speed, simplicity, and everyday utility.
        </p>
        
        <div className="hero-cta">
          <button 
            className="cta-button" 
            onClick={() => scrollToSection('apps')}
          >
            <Layers size={20} />
            Explore Software Products
          </button>
          <a 
            href="https://play.google.com/store/apps/dev?id=5490381095417506124&hl=en_IN" 
            className="cta-button cta-secondary" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <span>Google Play Store</span>
            <ExternalLink size={18} />
          </a>
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-number">50K+</span>
            <span className="stat-label">Product Downloads</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">4.8★</span>
            <span className="stat-label">Store Rating</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">5</span>
            <span className="stat-label">Software Products</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Privacy-First</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;